import { ChangeDetectorRef, Component , ElementRef, HostListener, Inject, Input, Renderer2, ViewChild} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import config from 'config/default.json';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import { DialogComponent } from '../../dialog/dialog.component';

@Component({
  selector: 'app-mail-sender',
  templateUrl: './mail-sender.component.html',
  styleUrls: ['./mail-sender.component.scss']
})
export class MailSenderComponent {
   constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
    public sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<MailSenderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { [x:string]: any }) {}

  rowInfos: { [x:string]: any } = this.data['row_infos'];
  userInfos: { [x:string]: any } = this.data['user_infos'];
  selectedRows: { [x:string]: any }[] = this.data['selected_rows'];
  platformInfos: { [x:string]: any } = this.data['platform_infos'];

  smsContentControl = new FormControl(); 
  emailObjectControl = new FormControl(); 
  emailContentControl = new FormControl(); 

  notificationObjectControl = new FormControl();
  notificationContentControl = new FormControl();

  emailAdresses: string = '';
  phoneNumbers: string = '';
  notificationPseudo: string = '';

  ngOnInit() {
    this.emailAdresses = this.selectedRows.filter((row:any)=>row.email != '').map((row:any) => row.email).join(', ');
    this.phoneNumbers = this.selectedRows.filter((row:any)=>row.phone != '').map((row:any) => row.phone).join(',');
    this.notificationPseudo = this.selectedRows.filter((row:any)=> row.token && row.token != '').map((row:any) => row.pseudo).join(',');
  }

  sendEmail(){
    this.sendMessageStudent('send_email');
  }
  sendSMS(){
    this.sendMessageStudent('send_sms');
  }
  sendNotification(){
    this.sendMessageStudent('send_notification')
  }
  
  sendMessageStudent(type:string){
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '60%',
      position: {top: '30px' },
      data: {page: 'confirmation', text: `Send this message ?`}
    });
    dialogRef.afterClosed().subscribe((confirm:boolean) => {
      if(confirm){
        let data = {
          type: type,
          students: this.selectedRows,
          email_contacts: this.emailAdresses,
          sms_content: this.smsContentControl.value,
          email_object: this.emailObjectControl.value,
          email_content: this.emailContentControl.value,
          notification_object: this.notificationObjectControl.value,
          notification_content: this.notificationContentControl.value,
          user_infos: this.userInfos,
          platform_infos: this.platformInfos
        }
        this.apiService.queryData(config.master.ndapi.url +'/enovsky/web/student/send_message', data).subscribe((response:any)=>{
          this.helper.showToast(response.message);
        })
      }
    });
  }
  close(){
    this.dialogRef.close();
  }

}
